/**
 * @file 追加・非表示の操作が可能なマスタメンテナンス画面の更新ボタン
 */

'use strict'

import Common from "../../Utils/Common"


/**
 * @classname BtnUpdateMasterMaintenance
 * @classdesc 追加・非表示の操作が可能なマスタメンテナンス画面の更新ボタン
 */
export default class BtnUpdateMasterMaintenance {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-update-master-maintenance')
	 */
	constructor($e, controller) {
		console.log(`BtnUpdateMasterMaintenance.constructor`)
		this._$e = $e
		this._controller = controller
		this._action = this._$e.data('action')
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnUpdateMasterMaintenance
	 * @return {undefined}
	 */
	onClick() {
		console.log(`BtnUpdateMasterMaintenance.onClick`)
		this._controller._listener.trigger('validate')
		if (!$('.is-invalid:not(.ignore-validation)').length) {
			this._controller.updateMasterMaintenance(this.appendFormData(), this._action)
		} else {
			Common.showErrorModal('入力内容に誤りがあります。')
		}
	}


	/**
	 * FormDataを作成
	 *
	 * @memberof BtnUpdateMasterMaintenance
	 * @return {undefined}
	 */
	appendFormData() {
		console.log(`BtnUpdateMasterMaintenance.appendFormData`)
		const formData = new FormData()
		$('.sortable-list__item').each((index, sortableListItem) => {
			const $sortableListItem = $(sortableListItem)
			const $surrogateKey = $sortableListItem.find('.surrogate_key')
			const $inputText = $sortableListItem.find('.input-text')
			const $inputText2 = $sortableListItem.find('.input-text2')
			const $inputCheckbtnInput = $sortableListItem.find('.input-checkbtn-input')

			formData.append($surrogateKey.attr('name'), $surrogateKey.val())
			formData.append($inputText.attr('name'), $inputText.val())
			formData.append($inputCheckbtnInput.attr('name'), $inputCheckbtnInput.prop('checked'))
			formData.append('display_order_num[]', index)
			if (!!$('[data-sortable-list-name="specified-contribution-type"]').length) {
				formData.append($inputText2.attr('name'), $inputText2.val())
			}
		})
		Common.logFormData(formData)
		return formData
	}
}
